interface SkeletonProps {
  className?: string;
  lines?: number;
}

export function Skeleton({ className = 'h-4 w-full', lines = 1 }: SkeletonProps) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className={`bg-gray-200 rounded animate-pulse ${className}`} />
      ))}
    </div>
  );
}
